import { useState } from "react";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import "../../styles/layout.css";

export default function AppLayout({ title, children }) {
    const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

    return (
        <div className="app-shell">
            <Sidebar
                mobileOpen={mobileSidebarOpen}
                onClose={() => setMobileSidebarOpen(false)}
            />

            <div className="app-main">
                <Topbar
                    title={title}
                    onOpenSidebar={() => setMobileSidebarOpen(true)}
                />
                <main className="app-content">{children}</main>
            </div>

            {mobileSidebarOpen && (
                <div
                    className="sidebar-backdrop"
                    onClick={() => setMobileSidebarOpen(false)}
                />
            )}
        </div>
    );
}